module.exports = __webpack_public_path__ + "img/youkemanyiduguanli.c3ca24f0.png";